'use es6';

import { MENU_TREE_LOAD } from 'simple-menus-core/actions/ActionTypes';
import { fetchPagesById } from 'simple-menus-core/actions/Pages';
export default (httpClient => ({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);
  switch (result.type) {
    case MENU_TREE_LOAD:
      {
        const {
          nodesById
        } = result;
        const id = Object.values(nodesById || {}).filter(node => node.pageLinkId || node.contentGroupId).map(node => node.pageLinkId || node.contentGroupId).join(',');
        if (id) {
          fetchPagesById(id)(dispatch, getState, {
            httpClient
          });
        }
        break;
      }
    default:
      {
        break;
      }
  }
  return result;
});